import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveBreeding: ['breeding', 'onSuccess', 'onError'],
  removeBreeding: ['breeding', 'onSuccess', 'onError'],
  breedingError: ['error']
})

const saveBreeding = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeBreeding = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const breedingError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.BREEDING_ERROR]: breedingError,

  [Types.SAVE_BREEDING]: saveBreeding,
  [Types.REMOVE_BREEDING]: removeBreeding,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as BreedingTypes,
  Creators as BreedingActions
}
